import { Suspense } from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router';

import * as Sentry from '@sentry/react';

import { getComposedRoutes } from '../registry/routes-registry';

const sentryCreateBrowserRouter = Sentry.wrapCreateBrowserRouterV7(createBrowserRouter);

const router = sentryCreateBrowserRouter(getComposedRoutes());

export const Router = () => {
  return (
    <Suspense
      fallback={
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
            fontSize: '16px',
            fontFamily: 'Roboto, sans-serif'
          }}
        >
          Loading...
        </div>
      }
    >
      <RouterProvider router={router} />
    </Suspense>
  );
};
